export enum ThemeEnum {
  light = 'light',
  dark = 'dark',
}

export type PaymentMethodsType = {
  ready: (leaving: Ref<boolean>) => Promise<void>;
  execute: (hooks: {
    token: string;
    onError: () => void;
    onSuccess: () => void;
    onCancel: () => void;
  }) => Promise<void>;
};

export const INJECTION_KEYS = {
  AuthorizationTheme: Symbol('AuthorizationTheme') as InjectionKey<ThemeEnum>,
  PaymentMethods: Symbol('PaymentMethods') as InjectionKey<PaymentMethodsType>,
};
